import React, { FC, memo } from 'react';
import { MeasurementEntry } from '@higo/common/src/features/ExaminationPage/sections/VitalSignsSection/common/MeasurementEntry';
import { MeasurementSkeleton } from '@higo/common/src/features/ExaminationPage/sections/VitalSignsSection/common/MeasurementSkeleton';
import { useBloodSaturationPhysicalExaminationQuery } from '@higo/common/src/features/ExaminationPage/hooks/queries';
import { defaultNAValue } from '@higo/common/src/utils';

export type BloodSaturationMeasurementEntryProps = {
  isAvailable?: boolean;
  examinationId: number;
  isVisitSection?: boolean;
  isCanceledStatus?: boolean;
};

const formatBloodSaturationMeasurement = (
  bloodSaturation?: number,
  unit?: string,
) => {
  if (bloodSaturation === undefined || bloodSaturation === null) {
    return defaultNAValue;
  }

  const normalizedUnit = unit?.trim() || '%';
  const unitSuffix = normalizedUnit === '%' ? '%' : ` ${normalizedUnit}`;

  return `SpO2 ${bloodSaturation}${unitSuffix}`;
};

export const BloodSaturationMeasurementEntry: FC<BloodSaturationMeasurementEntryProps> =
  memo(({ examinationId, isAvailable, isVisitSection, isCanceledStatus }) => {
    const { data, isLoading } = useBloodSaturationPhysicalExaminationQuery(
      examinationId,
      isAvailable,
    );
    const bloodSaturationData = data as
      | {
          bloodSaturation?: number;
          unit?: string;
        }
      | undefined;

    return (
      <MeasurementEntry
        isVisitSection={isVisitSection}
        title="Blood Saturation"
        measurement={
          isLoading ? (
            <MeasurementSkeleton />
          ) : (
            <span style={{ textTransform: 'none' }}>
              {formatBloodSaturationMeasurement(
                bloodSaturationData?.bloodSaturation,
                bloodSaturationData?.unit,
              )}
            </span>
          )
        }
        isCanceledStatus={isCanceledStatus}
      />
    );
  });
